import type { ClaimData } from '@truepill/tpos-types'
import { ClaimDataPaidStatus } from '@truepill/tpos-types'

const isPaidClaim = (claim: ClaimData | undefined): boolean => ClaimDataPaidStatus.includes(claim?.status || '')

export default isPaidClaim
